module.exports = __webpack_public_path__ + "9a070b8e96f2b5a96c7ebc409f5f3efc.svg";